AjaxQueue = require 'network/ajax-queue'
Auth = require 'db/auth'
Controller = require 'controller'
Util = require 'lib/util'
Promise = require 'bluebird'
Queue = require 'promise-queue'
f = require 'effing'
getExperiment = require 'lib/experiments/simple-test'
track = require 'debug/track'
xtend = require 'xtend'

queue = new Queue(3)

methodOf = (opts) ->
  (opts.type ? opts.method ? 'GET').toUpperCase()

performAjax = (opts) ->
  opts.data ?= {}

  # The API requires two forms of authentication (cookie + body) for non-GET
  # requests (to mitigate CSRF attacks), but does not require them for GETs.
  if methodOf(opts) != 'GET'
    opts.data.token = Auth.myToken()

  # But it always expects invitationTokens to be there. This is expected to
  # change in the future, so that this is consistent with token. When that
  # happens, you know what to do.
  opts.data.invitationTokens ?= Util.invitationTokens().join(',')

  # If it is flagged as a background operation that the user did not start,
  # then we do not want to warn about slow sending or break on possible
  # failures.
  if opts.background
    AjaxQueue.send(opts)
    return

  opts.modelCache ?= Controller.getCurrentModelCache()
  AjaxQueue.ajax(opts)
  return

module.exports = (opts, next) ->
  queue.add ->
    customSuccess = opts.success
    customError = opts.error

    new Promise (resolve, reject) ->
      opts = xtend opts,
        success: (args...) ->
          customSuccess?(args...)
          resolve(args)
          return
        error: (res, textStatus, error, fxDefault) ->
          if customError?
            customError(res, textStatus, error, fxDefault)
          else if opts.background
            track("ApiAjax", "Hidden Background Error", res.responseText)
          else if methodOf(opts) != 'GET'

            # See card https://trello.com/c/W3jvOvi8 for a discussion of the
            # history of how we got to dropping 4xx errors and where we think
            # that may be causing apparent data loss
            showApiErrors = getExperiment('showApiErrors')
            if showApiErrors.get('enabled')
              track("ApiAjax", "Test Show Server Error", res.responseText)
              fxDefault()
            else
              track("ApiAjax", "Hidden Server Error", res.responseText)
          reject([res, textStatus, error, fxDefault])
          return
      performAjax(opts)
      return
  .nodeify(next).catch(->).done()



// WEBPACK FOOTER //
// ./app/scripts/network/api-ajax.coffee